import React from 'react';
import {
  useMap,
  useMapsLibrary,
} from '@vis.gl/react-google-maps';
import {useSelector} from 'react-redux';

const MyFieldsAgvanceFieldBoundary = ({farmFieldPolygon, fillColor}) => {

  const clearMappedFarmFieldPolygons = useSelector(state => state.mapping.clearMappedFarmFieldPolygons);

  const map = useMap();

  const mapsLib = useMapsLibrary('maps');

  const [polygon, setPolygon] = React.useState(null);

  React.useEffect(() => {
    if (map === null || mapsLib === null) {
      return;
    }
    if (farmFieldPolygon !== null && polygon === null) {
      const p = new mapsLib.Polygon({
        paths: farmFieldPolygon,
        strokeColor: 'black',
        strokeOpacity: 1,
        strokeWeight: 3,
        fillColor: fillColor !== null ? fillColor : 'transparent',
        fillOpacity: 1,
        zIndex: 1,
      });
      p.setMap(map);
      setPolygon(p);
    }
    else if (farmFieldPolygon !== null && polygon !== null) {
      polygon.setOptions({
        paths: farmFieldPolygon,
        fillColor: fillColor !== null ? fillColor : 'transparent',
      });
      polygon.setMap(map);
    }
    else if (farmFieldPolygon === null && polygon !== null) {
      polygon.setMap(null);
    }
  }, [map, mapsLib, polygon, farmFieldPolygon, fillColor]);

  React.useEffect(() => {
    if (clearMappedFarmFieldPolygons === true && polygon !== null) {
      polygon.setMap(null);
    }
  }, [clearMappedFarmFieldPolygons, polygon]);

  React.useEffect(() => {
    return () => {
      if (polygon !== null) {
        polygon.setMap(null);
      }
    };
  }, [polygon]);

  return null;
};

export default MyFieldsAgvanceFieldBoundary;
